function vec2_add(v0, v1) {
    return [v0[0] + v1[0], v0[1] + v1[1]];
}

function vec2_sub(v0, v1) {
    return [v0[0] - v1[0], v0[1] - v1[1]];
}

function vec2_mul(v0, v1) {
    return [v0[0] * v1[0], v0[1] * v1[1]];
}

function vec2_angle(v0) {
    return Math.atan2(v0[1], v0[0]);
}

function vec2_length(v0) {
    return Math.sqrt(v0[0] * v0[0] + v0[1] * v0[1]);
}

function vec2_normalize(v0) {
    var len = vec2_length(v0)
    if (len > 0) {
        return vec2_mul(v0, [1/len, 1/len]);
    }
    return v0;
}

function vec2_distance(v0, v1) {
    var dx = v0[0] - v1[0];
    var dy = v0[1] - v1[1];
    return Math.sqrt(dx * dx + dy * dy);
}

export {
    vec2_add,
    vec2_sub,
    vec2_mul,
    vec2_angle,
    vec2_length,
    vec2_normalize,
    vec2_distance
};
